import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../common/apiClient'
import { useAuth } from '../contexts/AuthContext'
export type CafeRecurringSettings = {
  available: boolean
  enabled: boolean
  weekdays: number[]
  version: number
  hasDefault: boolean
  defaultPreview?: string | null
}
export const cafeRecurringOrderKey = (email?: string) =>
  ['cafe-recurring-order', email?.toLowerCase()] as const
export function useCafeRecurringSettings(email?: string) {
  const { user } = useAuth()
  const eligible =
    user?.team === 'System Development' && email?.toLowerCase() === user.email.toLowerCase()
  return useQuery<CafeRecurringSettings>({
    queryKey: cafeRecurringOrderKey(user?.email),
    queryFn: () => apiClient.get('/api/cafe/recurring-order'),
    enabled: eligible,
    staleTime: 300000,
    select: (data) => (eligible ? data : { ...data, available: false, enabled: false }),
  })
}
